import React from "react";
import { Box } from "@mui/material";

const RainbowDivider = (props) => {
  return (
    <Box
      className={"rainbow-divider"}
      {...props}
      sx={{
        height: "3px",
        minHeight: "3px",
        width: "100%",
        background:
          "linear-gradient(90deg, #0596A1 0%, #3971F6 19.71%, #9A45F4 42.31%, #FC7D06 61.54%, #F7E144 80.77%, #FF4626 100%)",
        ...props.sx,
      }}
    />
  );
};
export default RainbowDivider;
